import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
  dialogTitleContainer: {
    alignItems: 'center',
    display: 'flex',
    margin: 0,
    minHeight: 65,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  dialogTitle: {
    fontSize: '1.5rem',
    textTransform: 'uppercase',
  },
  dialogContentContainer: {
    padding: theme.spacing(2),
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))
